import React from 'react';
import { useNavigate } from 'react-router-dom';
import Vista from './layout/Vista';
import FaqFilterBar from './faq/FilterBar';
import FaqListRow from './faq/ListRow';
import {ReactComponent as IconAdd} from '../assets/icons/plus.svg';

export default function ListaFaq({ initialTitolo = '' }) {
    const navigate = useNavigate();

    const actions = [
        {
            label: "Crea nuova",
            icon: <IconAdd/>,
            onClick: () => navigate('/faq'),
            className: "add-btn"
        }
    ];

    return (
        <Vista
            apiCallEndpoint={"/listafaq"}
            initialFilterParams={{ titolo: initialTitolo }}
            FilterBarComponent={FaqFilterBar}
            ListRowComponent={FaqListRow}
            actions={actions}
            endMessage="Non ci sono altre FAQ"
        />
    );
}